<template>
  <div>
    <v-dialog v-model="dialog" width="620px" class="color">
      <v-card>
        <v-card-title class="primary white--text">
          <v-toolbar-title>DANH SÁCH TICKET</v-toolbar-title>
          <v-spacer />
          <v-icon color="white" @click="cancel">close</v-icon>
        </v-card-title>
        <v-card-text id="element-to-convert">
          <div>Danh sách ticket</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mt-5">
          <v-btn depressed color="primary" class="px-6 mr-2 mt-n4 mb-2 white--text d-none" @click="() => {}"
            >ĐÓNG</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { StudentTicket } from '@/plugins/api'
export default {
  components: {},
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    async openDialog(reportId, kind) {
      await StudentTicket.fetch({ report: reportId, kind })
    },
    async cancel() {
      this.dialog = false
    },
  },
}
</script>
